import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./find-a-car-menu.module.css";
import { ListItem } from "../list-item/list-item";
import { ListWrapper } from "../list-wrapper/list-wrapper";
import { useContext } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { mobileNavCard, navCard, popularMakes, resourcesAndGuides, shopByBudget, shopByType } from "../../../data/find-a-car";
import { NavCard } from "../nav-card/nav-card";
import { ShopByShapeThumbnail } from "../shop-by-shape-thumbnail/shop-by-shape-thumbnail";
import { parentLinks } from "../../../data/parent-menu";
import { MobileNavCard } from "../mobile-nav-card/mobile-nav-card";
export var FindACarMenu = function(param) {
    var isMobile = param.isMobile;
    var logicStore = useContext(SharedUiHeaderV2Context).logicStore;
    var handleTrackEvent = logicStore.handleTrackEvent, searchData = logicStore.searchData;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                className: styles.largeMobileNavContainer,
                children: popularMakes.map(function(make) {
                    /*#__PURE__*/ return _jsx(ListWrapper, {
                        heading: make.heading,
                        urlText: make.sectionLink,
                        href: make.href,
                        handleTrackEvent: function() {
                            return handleTrackEvent({
                                name: "click",
                                category: "mega menu",
                                label: parentLinks.FINDACAR,
                                action: "popular makes",
                                value: "view all cars"
                            });
                        },
                        children: /*#__PURE__*/ _jsx(_Fragment, {
                            children: make.navItems.map(function(item) {
                                var _$popularMakes = searchData ? searchData : null;
                                return /*#__PURE__*/ _jsx("li", {
                                    className: styles.listItem,
                                    children: /*#__PURE__*/ _jsx(ListItem, _object_spread_props(_object_spread({
                                        label: item.label,
                                        href: item.href
                                    }, _$popularMakes ? {
                                        apiData: _$popularMakes === null || _$popularMakes === void 0 ? void 0 : _$popularMakes[item.label.toLowerCase()]
                                    } : null), {
                                        handleClickEvent: function() {
                                            return handleTrackEvent({
                                                name: "click",
                                                category: "mega menu",
                                                label: parentLinks.FINDACAR,
                                                action: "popular makes",
                                                value: item.label
                                            });
                                        }
                                    }), item.label)
                                }, item.label);
                            })
                        })
                    }, make.heading);
                })
            }),
            /*#__PURE__*/ _jsxs("nav", {
                children: [
                    shopByBudget.map(function(budget) {
                        return /*#__PURE__*/ _jsx(ListWrapper, {
                            heading: budget.heading,
                            urlText: budget.sectionLink,
                            href: budget.href,
                            children: /*#__PURE__*/ _jsx("div", {
                                className: styles.smallMobileContainer,
                                children: budget.navItems.map(function(item) {
                                    return /*#__PURE__*/ _jsx("li", {
                                        className: styles.listItem,
                                        children: /*#__PURE__*/ _jsx(ListItem, {
                                            label: item.label,
                                            href: item.href,
                                            handleClickEvent: function() {
                                                return handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.FINDACAR,
                                                    action: "shop by budget",
                                                    value: item.label
                                                });
                                            }
                                        })
                                    }, item.label);
                                })
                            })
                        }, budget.heading);
                    }),
                    resourcesAndGuides.map(function(resource) {
                        return /*#__PURE__*/ _jsx(ListWrapper, {
                            heading: resource.heading,
                            urlText: resource.sectionLink,
                            href: resource.href,
                            children: /*#__PURE__*/ _jsx("nav", {
                                className: styles.smallMobileContainer,
                                children: resource.navItems.map(function(item) {
                                    return /*#__PURE__*/ _jsx("li", {
                                        className: styles.listItem,
                                        children: /*#__PURE__*/ _jsx(ListItem, {
                                            label: item.label,
                                            href: item.href,
                                            handleClickEvent: function() {
                                                return handleTrackEvent({
                                                    name: "click",
                                                    category: "mega menu",
                                                    label: parentLinks.FINDACAR,
                                                    action: "resources and guides",
                                                    value: item.label
                                                });
                                            }
                                        }, item.label)
                                    }, item.label);
                                })
                            })
                        }, resource.sectionTitle);
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ _jsx("nav", {
                className: styles.largeMobileNavContainer,
                children: /*#__PURE__*/ _jsx(MobileNavCard, {
                    heading: mobileNavCard.heading,
                    imageSrc: mobileNavCard.image,
                    alt: mobileNavCard.alt,
                    link: mobileNavCard.link,
                    href: mobileNavCard.href,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.FINDACAR,
                            action: "help me choose"
                        });
                    }
                })
            }),
            /*#__PURE__*/ _jsx("nav", {
                children: shopByType.map(function(type) {
                    return /*#__PURE__*/ _jsx(ListWrapper, {
                        heading: type.heading,
                        urlText: type.sectionLink,
                        href: type.href,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.shopByTypeContainer,
                            children: type.cards.map(function(item) {
                                return /*#__PURE__*/ _jsx(ShopByShapeThumbnail, {
                                    title: item.label,
                                    href: item.href,
                                    image: item.image,
                                    alt: item.alt,
                                    handleTrackEvent: function() {
                                        return handleTrackEvent({
                                            name: "click",
                                            category: "mega menu",
                                            label: parentLinks.FINDACAR,
                                            action: "shop by type",
                                            value: item.label
                                        });
                                    }
                                }, item.label);
                            })
                        })
                    }, type.sectionTitle);
                })
            }),
            !isMobile && /*#__PURE__*/ _jsx("nav", {
                children: /*#__PURE__*/ _jsx(NavCard, {
                    heading: navCard.heading,
                    subHeading: navCard.body,
                    link: navCard.sectionLink,
                    href: navCard.href,
                    imageSrc: navCard.image,
                    alt: navCard.alt,
                    handleTrackEvent: function() {
                        return handleTrackEvent({
                            name: "click",
                            category: "mega menu",
                            label: parentLinks.FINDACAR,
                            action: "help me choose"
                        });
                    }
                })
            })
        ]
    });
};
